<template>
  <form class="create-feed-form" @submit.prevent="login">
    <div class="create-feed-form--first-row">
      <div class="create-feed-form--col-left">
        <label class="input-block mb-15">
          <div class="input-block--text">Логин:</div>
          <input type="text" v-model.trim="form.login">
        </label>
        <label class="input-block mb-15">
          <div class="input-block--text">Пароль:</div>
          <input type="password" v-model.trim="form.password">
        </label>
      </div>
    </div>
    <button class="btn btn-blue create-feed-form--submit" type="submit" :disabled="!formValid">Войти</button>
  </form>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      form: {
        login: '',
        password: '',
      },
    };
  },
  computed: {
    formValid() {
      return this.form.login.length > 0 && this.form.password.length > 0;
    }
  },
  methods: {
    async login() {
      try {
        this.$globalSpinner.show();

        const res = await this.$api.login(this.form.login, this.form.password);
        this.$auth.setToken(res.token);
        this.$router.push({ name: 'index' });
      } catch(e) {
        this.$notification.error(e.status === 404 ? 'Неверные логин или пароль' : 'Ошибка входа');
      } finally {
        this.$globalSpinner.hide();
      }
    }
  },
}
</script>

<style scoped>

</style>
